import * as React from "react";
import { connect } from "react-redux";
import { AxiosResponse } from "axios";

import { IMasterServices, IService } from "app/api/types";
import { getServices } from "app/api/redux/Services/actions";

import "./styles.scss";
import MasterService from "../MasterService";

interface IMasterServicesProps {
  onChange: (e: any) => void;
  onDelete: (serviceId: number) => void;
  onAdd: (serviceId: number) => void;
  masterServices: IMasterServices[];
  serviceList?: IService[];
  getServices: () => Promise<AxiosResponse>;
  serviceErrorIds: Set<Number>;
}

class MasterServices extends React.Component<IMasterServicesProps> {
  componentDidMount() {
    this.props.getServices();
  }

  getFreeId = () => {
    const { serviceList, masterServices } = this.props;

    let mastersIds: number[] = masterServices.map((item) => item.serviceId);
    let serviceIds: any[] = serviceList!.map((item) => Number(item.id));

    const freeIds = serviceIds.filter((id) => !mastersIds.includes(id));

    return freeIds;
  };

  render() {
    const freeIds = this.getFreeId();

    return (
      <div className="master-services">
        {freeIds.length !== 0 && (
          <p
            className="master-services__add"
            onClick={() => this.props.onAdd(freeIds[0])}
          >
            + добавить услугу
          </p>
        )}
        {this.props.masterServices.map((item) => (
          <MasterService
            key={item.serviceId}
            service={item}
            onChange={this.props.onChange}
            onDelete={this.props.onDelete}
            serviceList={this.props.serviceList}
            masterServices={this.props.masterServices}
            isError={this.props.serviceErrorIds.has(item.serviceId)}
          />
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    serviceList: state.services.serviceList,
  };
};
export default connect(mapStateToProps, { getServices })(MasterServices);
